import styled from "styled-components/macro";

export const Download = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  cursor: "pointer",
  color: theme.color.brandPrimary.light,

  svg: {
    color: theme.color.brandPrimary.light,
  },
}));
